/**
 * Zentrale Fahrzeugtyp-Konfiguration
 *
 * Alle Fahrzeugtypen, Sitzplätze, Spezialfähigkeiten und Kompatibilitätslogik
 * werden hier definiert und von allen Komponenten importiert.
 */

// Fahrzeugtypen mit Bezeichnung und Sitzplätzen
export const VEHICLE_TYPES = {
  1: { label: 'PKW', seats: 4, description: 'PKW (bis 4 Sitzplätze)' },
  2: { label: 'Großraum', seats: 6, description: 'Großraum (bis 6 Sitzplätze)' },
  3: { label: 'Kleinbus', seats: 7, description: 'Kleinbus (bis 7 Sitzplätze)' },
  4: { label: 'Kleinbus', seats: 8, description: 'Kleinbus (bis 8 Sitzplätze)' },
};

// Array für Select-Dropdowns
export const VEHICLE_TYPE_OPTIONS = [
  { value: 1, label: 'PKW (bis 4 Sitzplätze)' },
  { value: 2, label: 'Großraum (bis 6 Sitzplätze)' },
  { value: 3, label: 'Kleinbus (bis 7 Sitzplätze)' },
  { value: 4, label: 'Kleinbus (bis 8 Sitzplätze)' },
];

// Alle verfügbaren Spezialfähigkeiten
export const SPECIAL_CAPABILITIES = {
  kombi: 'Kombi',
  limousine: 'Limousine',
  rollstuhl: 'Rollstuhlfahrzeug',
  tragestuhl: 'Tragestuhlfahrzeug',
  liegend: 'Liegendfahrzeug',
  tiefer_einstieg: 'Tiefer Einstieg',
  hoher_einstieg: 'Hoher Einstieg',
};

// Welche Fähigkeiten für welchen Fahrzeugtyp verfügbar sind
export const CAPABILITIES_PER_TYPE = {
  1: ['kombi', 'limousine', 'tiefer_einstieg', 'hoher_einstieg'],
  2: ['rollstuhl', 'tiefer_einstieg', 'hoher_einstieg'],
  3: ['rollstuhl', 'tragestuhl', 'liegend', 'tiefer_einstieg', 'hoher_einstieg'],
  4: ['rollstuhl', 'tragestuhl', 'liegend', 'tiefer_einstieg', 'hoher_einstieg'],
};

// Kompatibilitätsmatrix: Welche Fahrzeugtypen können eine Bestellung bedienen?
// Aufsteigend: Größere Fahrzeuge können kleinere Bestellungen annehmen
export const getCompatibleVehicleTypes = (orderVehicleType) => {
  switch (orderVehicleType) {
    case 1: return [1, 2, 3, 4];
    case 2: return [2, 3, 4];
    case 3: return [3, 4];
    case 4: return [4];
    default: return [1, 2, 3, 4];
  }
};

// Prüft ob ein Fahrzeugtyp eine Bestellung bedienen kann
export const isVehicleCompatible = (driverVehicleType, orderVehicleType) => {
  return getCompatibleVehicleTypes(orderVehicleType).includes(driverVehicleType);
};

// Label für einen Fahrzeugtyp
export const getVehicleTypeLabel = (type) => {
  return VEHICLE_TYPES[type]?.label || 'Unbekannt';
};

// Sitzplätze für einen Fahrzeugtyp
export const getVehicleTypeSeats = (type) => {
  return VEHICLE_TYPES[type]?.seats || 0;
};

// Vollständige Beschreibung für einen Fahrzeugtyp (z.B. für Dropdowns)
export const getVehicleTypeDescription = (type) => {
  return VEHICLE_TYPES[type]?.description || 'Unbekannt';
};

// Label für eine Spezialfähigkeit
export const getCapabilityLabel = (capability) => {
  return SPECIAL_CAPABILITIES[capability] || capability;
};

// Formatiert Fahrzeugtyp + Capabilities als Display-String
export const formatVehicleWithCapabilities = (vehicleType, capabilities) => {
  const typeLabel = getVehicleTypeLabel(vehicleType);
  if (!capabilities || capabilities.length === 0) return typeLabel;
  const capLabels = capabilities.map(c => getCapabilityLabel(c)).join(', ');
  return `${typeLabel} (${capLabels})`;
};

// Backward-Compat: Alten specialVehicleType-String in Array umwandeln
export const migrateSpecialVehicleType = (data) => {
  if (data.specialCapabilities && Array.isArray(data.specialCapabilities)) {
    return data.specialCapabilities;
  }
  if (data.specialVehicleType) {
    // kleinbus_7 und kleinbus_8 sind jetzt eigene Typen, keine Capabilities mehr
    if (['kleinbus_7', 'kleinbus_8'].includes(data.specialVehicleType)) {
      return [];
    }
    return [data.specialVehicleType];
  }
  return [];
};
